import routes from './seo-routes.json';

/** Single source of truth for page-level SEO (also read by scripts/prerender-meta.js at build time). */
export const SITE = {
  url: 'https://quantum-stack.com',
  name: 'Quantum Stack',
  image: 'https://quantum-stack.com/og-image.png',
  locale: 'en_IN',
};

export const ROUTES = routes;

export function normalizePath(pathname) {
  const p = (pathname || '/').replace(/\/+$/, '');
  return p === '' ? '/' : p;
}

export function metaFor(pathname) {
  return ROUTES[normalizePath(pathname)] || null;
}
